module.exports = __webpack_public_path__ + "../resources/img/ic_re_storm_solid.24adb2e3.svg";